import { Routes, Route, Navigate } from "react-router-dom";
import Factory from "../components/Factory/Factory";
import Products from "../components/Products/Products";
import Login from "../components/Auth/Login";
import ProtectedRoute from "./ProtectedRoute";
import Vendor from "../components/Vendor/Vendor";
import User from "../components/User/User";
import Quality from "../components/Quality/Quality";
import SubQuality from "../components/SubQuality/SubQuality";
import Reports from "../components/Reports/Reports";
import LabourCost from "../components/LabourCost/LabourCost";
import Operator from "../components/Operator/Operator";
import LeafWareHouse from "../components/LeafWareHouse/LeafWareHouse";
import CartoonType from "../components/CartoonType/CartoonType";
import PlasticType from "../components/PlasticType/PlasticType";
import Production from "../components/Production/Production";
import Mold from "../components/Mold/Mold";
import CartoonStock from "../components/CartoonStock/CartoonStock";
import PlasticStock from "../components/PlasticStock/PlasticStock";
import LeafStock from "../components/LeafStock/LeafStock";
import StickerStock from "../components/StickerStock/StickerStock";
import CartoonWithDraw from "../components/CartoonWithDraw/CartoonWithDraw";
import PlasticWithDraw from "../components/PlasticWithDraw/PlasticWithDraw";
const Routing = ({ userAuth }) => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <ProtectedRoute userAuth={userAuth}>
            <Reports />
          </ProtectedRoute>
        }
      ></Route>
      <Route
        path="/products"
        element={
          <ProtectedRoute userAuth={userAuth}>
            <Products />
          </ProtectedRoute>
        }
      ></Route>
      <Route
        path="/production"
        element={
          <ProtectedRoute userAuth={userAuth}>
            <Production />
          </ProtectedRoute>
        }
      ></Route>
      <Route
        path="/vendor"
        element={
          <ProtectedRoute userAuth={userAuth}>
            <Vendor />
          </ProtectedRoute>
        }
      ></Route>
      <Route
        path="/mold"
        element={
          <ProtectedRoute userAuth={userAuth}>
            <Mold />
          </ProtectedRoute>
        }
      ></Route>
      <Route
        path="/labourcost"
        element={
          <ProtectedRoute userAuth={userAuth}>
            <LabourCost />
          </ProtectedRoute>
        }
      />
      <Route
        path="/quality"
        element={
          <ProtectedRoute userAuth={userAuth}>
            <Quality />
          </ProtectedRoute>
        }
      />
      <Route
        path="/subquality"
        element={
          <ProtectedRoute userAuth={userAuth}>
            <SubQuality />
          </ProtectedRoute>
        }
      />
      <Route
        path="/users"
        element={
          <ProtectedRoute userAuth={userAuth}>
            <User />
          </ProtectedRoute>
        }
      />
      <Route
        path="/operator"
        element={
          <ProtectedRoute userAuth={userAuth}>
            <Operator />
          </ProtectedRoute>
        }
      />
      <Route
        path="/factory"
        element={
          <ProtectedRoute userAuth={userAuth}>
            <Factory type="factory" />
          </ProtectedRoute>
        }
      ></Route>
      <Route
        path="/leafwarehouse"
        element={
          <ProtectedRoute userAuth={userAuth}>
            <LeafWareHouse />
          </ProtectedRoute>
        }
      />
      <Route
        path="/leafstock"
        element={
          <ProtectedRoute userAuth={userAuth}>
            <LeafStock />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cartoontype"
        element={
          <ProtectedRoute userAuth={userAuth}>
            <CartoonType />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cartoonstock"
        element={
          <ProtectedRoute userAuth={userAuth}>
            <CartoonStock />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cartoonWithDraw"
        element={
          <ProtectedRoute userAuth={userAuth}>
            <CartoonWithDraw />
          </ProtectedRoute>
        }
      />
      <Route
        path="/plasticWithDraw"
        element={
          <ProtectedRoute userAuth={userAuth}>
            <PlasticWithDraw />
          </ProtectedRoute>
        }
      />
      =
      <Route
        path="/plastictype"
        element={
          <ProtectedRoute userAuth={userAuth}>
            <PlasticType />
          </ProtectedRoute>
        }
      />
      <Route
        path="/plasticstock"
        element={
          <ProtectedRoute userAuth={userAuth}>
            <PlasticStock />
          </ProtectedRoute>
        }
      />
      <Route
        path="/stickerstock"
        element={
          <ProtectedRoute userAuth={userAuth}>
            <StickerStock />
          </ProtectedRoute>
        }
      />
      {/* stickerstock */}
      <Route
        path="/login"
        element={
          <ProtectedRoute userAuth={userAuth} type="login">
            <Login />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};
export default Routing;
